export class ProductPriceRangeData {
    min: number = 0; // From this unit range
    max: number = -1; // To this unit range
    price: number = 5; // Price per 1 unit
}
